// extracted by mini-css-extract-plugin
module.exports = {"rateOption":"xh","rateIcon":"xi","rateLabel":"xj","inPlayer":"xk","rateIconWrapper":"xl","inPlayerRateModal":"xm"};